export const LIABILITY_INFO = 'liability';
export const POSTBOX = 'postbox';
export const NOTIFICATIONS = 'notifications';
export const LIABILITY_TABLE = 'liability-table';
